/**
 * kult-b2b-shop.js — Firmenkunden-Ansichten von Kaffee-Übersicht und Produktseite (templates collection.b2b,
 * product.b2b, product.b2b-set). Kennzeichnet den Warenkorb als Firmenbestellung, sobald dort etwas hineingelegt wird:
 * Warenkorb-Attribut „Firmenbestellung“ = „Ja“ (steht später in der Bestellung; die App setzt daraus den Bestell-Tag
 * firmenbestellung und den Kundentag firmenkunde, lib/segment.server.ts). Auslöser ist das Ereignis "kult:cart:add",
 * das alle Kauf-Skripte nach dem Hinzufügen senden. Außerdem merkt das Skript den Bereich der Sitzung (b2b).
 * Kein Framework, keine externen Skripte.
 */
(function () {
  'use strict';
  if (window.__kultB2bShop) return;
  window.__kultB2bShop = true;
  try { window.sessionStorage.setItem('kult:bereich', 'b2b'); } catch (e) { /* kein Speicher */ }
  /* Attribut setzen, einmal je Seite; liefert ein Promise, auf das assets/kult-cart.js vor der Weiterleitung auf
     /cart?view=b2b wartet (Cowork Mo-23 U1, 12.10.2026: sonst brach der Seitenwechsel den Update-Request ab). */
  var pending = null;
  function mark() {
    if (pending) return pending;
    pending = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Firmenbestellung: 'Ja' } })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      document.dispatchEvent(new CustomEvent('kult:cart:updated', { detail: { cart: cart } }));
      return cart;
    }).catch(function () { pending = null; return null; });
    return pending;
  }
  window.KultB2bShop = { mark: mark };
  document.addEventListener('kult:cart:add', function () { mark(); });
  /* Edge-Case (Philip 14.10.2026): Warenkorb in der Privat-Ansicht gefüllt, dann in die Firmenkunden-Ansicht
     gewechselt → ohne Attribut sähe die Kasse eine Privatbestellung (versandfrei ab Grenze). Deshalb beim Betreten
     einer Firmenkunden-Ansicht mit gefülltem Warenkorb das Attribut nachziehen; die Gegenrichtung räumt
     assets/kult-b2b-reset.js im Privatbereich auf. */
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (cart && cart.item_count > 0 && !(cart.attributes && cart.attributes.Firmenbestellung)) mark();
    })
    .catch(function () { /* Kasse fängt eingeloggte Firmenkundinnen über den Kunden-Tag */ });
})();
